import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';
import DialogsWithIcon from '@Containers/Dialogs/DialogsWithIcon';
import store from '@Store';
import { openLoginModal } from '@Pages/Login/LoginActions';
import { openRegisterModal } from '@Pages/Login/Register/RegisterActions';
import AppStorage from '@Services/AppStorage';

import './LoginPromptDialog.scss';

export default function LoginPromptDialog(props) {
  const { selfClose } = props;

  const flagReturnToLastState = () => {
    AppStorage.instance.set('revisitLastState', true);
  };

  const handleRegisterClick = () => {
    selfClose();
    flagReturnToLastState();
    store.dispatch(openRegisterModal());
  };

  const handleLoginClick = () => {
    selfClose();
    flagReturnToLastState();
    store.dispatch(openLoginModal());
  };

  return (
    <DialogsWithIcon
      {...props}
      className="login-prompt-dialog"
      character="!"
      layoutType="info"
      headerClassName="rx-border-none"
      footerClassName="rx-border-none"
      header="Sign in to use supplier preferences"
      size="md"
      footer={
        <div className="els-btn-group-right">
          <Button data-e2e="dialog-register" type="secondary" onClick={handleRegisterClick} className="e2e-dialog-register">
            Register
          </Button>
          <Button data-e2e="dialog-sign-in" type="primary" onClick={handleLoginClick} className="e2e-dialog-signIn">
            Sign in
          </Button>
        </div>
      }>
      To use this feature you need to be a registered user of Reaxys.
    </DialogsWithIcon>
  );
}

LoginPromptDialog.propTypes = {
  selfClose: PropTypes.func.isRequired,
};
